// extracted by mini-css-extract-plugin
module.exports = {"root":"bv_b4"};